var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"options-pick-answer"},_vm._l((_vm.slideOptions),function(option,index){return _c('QuizOption',{key:option.id,class:{
      'correct': option.correct,
      'incorrect': !option.correct,
      'multiple': _vm.multipleChoice,
      'checked': _vm.answer.includes(option.id),
      'massive': _vm.isMassiveOptions,
    },attrs:{"index":index,"option":option}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }